/* */ 
var $export = require('./_export');
$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});
